import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, EventEmitter, HostListener
  , inject, input, linkedSignal, OnDestroy, OnInit, Output, 
  signal, 
  ViewChild} from '@angular/core';
import { MatInputModule } from '@angular/material/input';
// import { RouterOutlet } from '@angular/router';
// import { FuseAlertComponent } from '@fuse/components/alert';
// import { ItmToolbarComponent } from '@itm/components/toolbar';
import { takeUntil } from 'rxjs/operators';
import { ActionPOSubType, ActionPRSubType, ActionStatus, ActionType, IActions, IChat, IChatMsg } from '../../../utilities';
import { TextAreaModule, TextBoxComponent, TextBoxModule, UploaderComponent, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { CacNotifyService } from 'app/modules/admin/shared/services/cac.notify.service';
import { FormsModule } from '@angular/forms';
import { AggregateService, GridComponent, GridModule, GroupService, PageService } from '@syncfusion/ej2-angular-grids';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
// import { FuseDrawerComponent } from '@fuse/components/drawer';
import { MatDialog } from '@angular/material/dialog';
import { DocumentViewerModalComponent } from '../../../shared/document-viewer-modal.component';
import { ItmBaseComponent } from '@itm/components/itm.base.component';
import { AuditDetailComponent } from '@itm/components/audit-detail/audit-detail.component';
// import { ItmUserService } from '@itm/services';
import { DomSanitizer } from '@angular/platform-browser';
import { LayoutService } from '@itm/services';
import { CacActionService } from '../../../cac.action.service';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { messages } from 'app/mock-api/apps/chat/data';
import { Utilities } from '@itm/constants/utilities';

@Component({
    selector: 'purchase-requisition-sidebar',
    templateUrl: './purchase-requisition-sidebar.component.html',
    styleUrls: ['./purchase-requisition-sidebar.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      // RouterOutlet, 
      CommonModule, GridModule
      // , ItmToolbarComponent
      // , FuseAlertComponent
      , TextBoxModule, AccordionModule
      // , FuseDrawerComponent
      , AuditDetailComponent
      , MatInputModule, TextAreaModule, FormsModule, UploaderModule, DialogModule],
    providers: [
      AggregateService
      , GroupService
      , PageService
    ],
})
export class PurchaseRequisitionSidebarComponent extends ItmBaseComponent implements OnInit, OnDestroy  {

  additionalHeight: number = 70;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const innerHeight = event.target.innerHeight;
    this.containerHeight = innerHeight - this.additionalHeight;
    this.setInnerContainerHeight();
  }

  @ViewChild('grid') public grid?: GridComponent;
  @ViewChild('comment', { static: false }) comment: TextBoxComponent;
  @ViewChild('chatFile') public chatFile!: UploaderComponent;

  @Output() fireRejectEvent = new EventEmitter<any>();
  @Output() fireApproveEvent = new EventEmitter<any>();
  @Output() fireRequestInfoEvent = new EventEmitter<any>();

  private readonly _cacNotifyService = inject(CacNotifyService);
  private readonly _layoutService = inject(LayoutService);

  originalSelectedLineItems: any;
  actionData = input<IActions>();
  inProgress = input<boolean>();
  isRejecting = signal<boolean>(false);
  lineItems = computed(() => {
    // this.originalSelectedLineItems = this.actionData()?.lineItems.filter(f => f.isApproved == true).map(m => m.id)
    return this.actionData()?.lineItems;
    // const items = this.actionData()?.lineItems ?? [];
    // return items.map(item => ({
    //   ...item,
    //   isApproved: true
    // }));
  });
  
  quotes = computed(() => {
    return this.actionData()?.additional?.quotes;
  });
  
  singleSourcePurchaseDetails = computed(() => {
    return this.actionData()?.additional?.singleSourcePurchaseDetails;
  });
  actionButton = computed(() => {
    return this.actionData()?.actionButton;
  });

  totalAmount = computed(() => {
    return this.actionData()?.additional?.totalAmount;
  });

  prSubTitle = computed(() => {
    const isSingleSourcePurchase = this.actionData()?.additional?.isSingleSourcePurchase

    let msg = (isSingleSourcePurchase && "This is a Single Source purchase requisition") || "Purchase requisition";

    if(this.actionData()?.actionSubTypeId==this.ActionPRSubType.SubHirePRRequest){
      // msg = `Sub Hire`;
    }
    msg += ` from Onsite Rental Group.`;
    const approvers: any = this.actionData()?.additional?.approvers;
    if (approvers) {
      if(approvers.length === 0) {
        // msg = `Purchase requisition from Onsite Rental Group.`;
      }
      else if (approvers.length > 0) {
        const approver = approvers[0];
        if (approver.userEmail.toLowerCase() == this.getLoggedInUserEmail().toLowerCase()) {
          if (this.actionData()?.status == ActionStatus.Cancelled) {
            msg+= ` This purchase requisition has been cancelled by the requester.`;
            msg = `<div class="px-[2px] py-[4px] bg-[#FEC435]">${msg}</div>`;
          }
          else {
            msg += ` Please review and take appropriate action.`;
            msg = `<div class="px-[2px] py-[4px]">${msg}</div>`;
          }
          return this.sanitizer.bypassSecurityTrustHtml(msg);
        }
        else {
          if (this.actionData()?.lineItems.some(f => f.actionType == this.actionType.Requested)
            && this.actionData()?.chats[0]?.approverUserEmail
            && this.actionData()?.additional?.requesterUser.userEmail == this.getLoggedInUserEmail().toLowerCase()) {
            msg += ` This purchase requisition is currently with the approver (<strong>${approver?.userName}</strong>). 
            You are required to provide additional information as requested. Please add your response in the comments below.`;
          }
          else {
            msg += ` This purchase requisition is currently with the approver (<strong>${approver?.userName}</strong>). 
            You have already actioned this request, and no further action is required from you at this stage.`;
          }
          msg = `<div class="px-[2px] py-[4px] bg-[#FEC435]">${msg}</div>`;
          return this.sanitizer.bypassSecurityTrustHtml(msg);
        }
      }
    }
    msg = `<div class="px-[2px] py-[4px]">${msg}</div>`;
    return this.sanitizer.bypassSecurityTrustHtml(msg);
  });
  
  poSubTitle = computed(() => {
    let msg = "Purchase order change request (POCO)";
    msg += ` from Onsite Rental Group.`;
    const approvers: any = this.actionData()?.additional?.approvers;
    if (approvers) {
      if(approvers.length === 0) {
        // msg = `Purchase requisition from Onsite Rental Group.`;
      }
      else if (approvers.length > 0) {
        const approver = approvers[0];
        if (approver.userEmail.toLowerCase() == this.getLoggedInUserEmail().toLowerCase()) {
          if (this.actionData()?.status == ActionStatus.Cancelled) {
            msg+= ` This purchase order change request (POCO) has been cancelled by the requester.`;
            msg = `<div class="px-[2px] py-[4px] bg-[#FEC435]">${msg}</div>`;
          }
          else {
            msg += ` Please review and take appropriate action.`;
            msg = `<div class="px-[2px] py-[4px]">${msg}</div>`;
          }
          return this.sanitizer.bypassSecurityTrustHtml(msg);
        }
        else {
          if (this.actionData()?.lineItems.some(f => f.actionType == this.actionType.Requested)
            && this.actionData()?.chats[0]?.approverUserEmail
            && this.actionData()?.additional?.requesterUser.userEmail == this.getLoggedInUserEmail().toLowerCase()) {
            msg += ` This purchase order change request (POCO) is currently with the approver (<strong>${approver?.userName}</strong>). 
            You are required to provide additional information as requested. Please add your response in the comments below.`;
          }
          else {
            msg += ` This purchase order change request (POCO) is currently with the approver (<strong>${approver?.userName}</strong>). 
            You have already actioned this request, and no further action is required from you at this stage.`;
          }
          msg = `<div class="px-[2px] py-[4px] bg-[#FEC435]">${msg}</div>`;
          return this.sanitizer.bypassSecurityTrustHtml(msg);
        }
      }
    }
    msg = `<div class="px-[2px] py-[4px]">${msg}</div>`;
    return this.sanitizer.bypassSecurityTrustHtml(msg);
  });

  supplier = computed(() => {
    return this.actionData()?.additional?.supplier;
  });
  chats = computed(() => {
    return this.actionData()?.chats;
  });

  disabledSendButton = signal(true);
  disabledRejectConfirmButton = signal(true);
  private isRejectSubmitting = false;

  visibleSendComment: boolean = false;
  ActionType = ActionType;
  ActionPRSubType = ActionPRSubType;
  ActionPOSubType = ActionPOSubType;
  isMobile = this._layoutService.isMobileView;

  chatMsg: IChatMsg = {
    fileName: undefined,
    message: '',
  };

  actionType = {
    Approved: 'Approved',
    Rejected: 'Rejected',
    Requested: 'Requested',
  }

  selectionSettings = {
    type: 'Multiple',
    mode: 'Row',
    checkboxOnly: false
  };

  public uploaderButtons = {
    browse: ''
  };
  private readonly _cacService = inject(CacActionService);
  actionDataSig = linkedSignal<any>(() => this.actionData());
  constructor(private dialog: MatDialog, private sanitizer: DomSanitizer) {
    super();

    effect(() => {
      // this.showReason = false;
      // this._changeDetectorRef.detectChanges();
      // console.log(this.prSubTitle())
    })
  }

  ngOnInit(): void {
    this.containerHeight = window.innerHeight - this.additionalHeight;
    this.setInnerContainerHeight();

    this._cacNotifyService.sidebarOpenedStatus$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(x => {
      this.visibleSendComment = false;
      this.chatMsg.message = '';
      this._changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
  }

  onRowDataBound(args: any): void {
    args.isSelectable = true;
    
    if(this.actionButton().disabledApproved==true){
      args.isSelectable = false;
    }
    if(args.data.prevActionType == this.actionType.Rejected){
      args.isSelectable = false;
    }
    if(args.data.actionType == this.actionType.Approved){
      args.isSelectable = false;
    }
    
    // If SSA approver and item is contracted, make it not selectable
    if(this.actionData()?.additional?.approvers && this.actionData().additional?.approvers[0]?.isSSAApprover && args.data.isContracted){
      args.isSelectable = false;
    }

    if (this.actionData()?.actionTypeId === ActionType.PurchaseOrder
        && args.data?.origin === 'Baseplan') {
      args.isSelectable = false;
    }

    // const actions = [this.actionType.Rejected, this.actionType.Approved];
    // // if (actions.includes(args.data.prevActionType)) {
    // // if(args.data.prevActionType == this.actionType.Rejected || this.actionButton().disabledApproved) {
    // if(args.data.prevActionType == this.actionType.Rejected) {
    //   // 1. Disable selection
    //   args.row.classList.add('e-disabled-row');
    //   args.row.style.pointerEvents = 'none';
    //   args.row.style.opacity = '0.5';
  
    //   // 2. Disable checkbox manually
    //   const checkbox = args.row.querySelector('input.e-checkselect');
    //   if (checkbox) {
    //     checkbox.disabled = true;
    //     args.isSelectable = false;
    //   }
    // }
  }

  onGridDataBound(): void {
    const indexesToSelect: number[] = [];

    this.lineItems()?.forEach((item, index) => {
      if (item.actionType === this.actionType.Approved) {
        indexesToSelect.push(index);
      }
    });
    
    if (indexesToSelect.length > 0) {
      // this.grid.selectRows(indexesToSelect);
    }
  }

  onRequestInfoClick(e: any){
    if (this.actionButton()?.disabledRequestInfo) {
      return;
    }
    this.isRejecting.set(false);
    const selectedItems: any = this.grid?.getSelectedRecords();
    this.chatMsg.message = '';
    if(selectedItems && selectedItems.length==1){
      const user = this._itmUserService.getLoggedInUser();
      let userName = '';
      if(user){
        userName = user.email.split("@")[0];
      }
      const itemName = selectedItems[0].name?.trim();
      this.chatMsg.message = itemName
        ? `${itemName} - ${userName} has requested further info on this`
        : `${userName} has requested further info on this`;
    }
    this.setDisabledSendButton(this.chatMsg.message);

    this.visibleSendComment = !this.visibleSendComment;

    if(this.visibleSendComment){
      const interval = setInterval(() => {
        if(this.comment){
          clearInterval(interval);
          this.comment.focusIn();
        }      
      }, 200);
    }
  }

  onCommentSendClick(e: any){
    if(!this.chatMsg.message){
      this._toastr.showInfo('Please enter comment before sending.');
      return;
    }

    const selectedItems: any = this.grid?.getSelectedRecords();

    // if(this.isRejecting()){
    //     const confirmationMessage = `Are you sure you want to reject ?`;
    //     const confirmation = this._fuseConfirmationService.open(
    //       {
    //         title: 'Confirmation',
    //         message: confirmationMessage,
    //         panelClass: "archive-dialog-panel",
    //         dismissible: true,
    //         icon: {
    //           show: true,
    //           color: 'info'
    //         },
    //         actions: {
    //           confirm: {
    //             show: true,
    //             label: 'Confirm',

    //           },
    //           cancel: {
    //             show: true,
    //             label: 'Cancel'
    //           }
    //         }
    //       }
    //     );

    //     // console.log(this.actionData());
    //     confirmation.afterClosed().subscribe((result) => {
    //       if (result === 'confirmed') {
    //         const formData = new FormData();
    //         const files = this.chatFile.getFilesData();
    //         if (files.length > 0) {
    //           const file = files[0];
    //           const ticks = Date.now();
    //           formData.append('file', new File([file.rawFile], `${file.name}`, { type: this.getContentType(file.name) }));
    //         }
    //         formData.append('chatMsg', JSON.stringify(this.chatMsg));
            
    //         this.lineItems().filter(f => selectedItems.map(m => m.id).includes(f.id)).map(m => {
    //           m.actionType = m.prevActionType = 'Rejected';
    //         });


    //         this._cacService.sendRejctMessage(this.actionData().id, formData).subscribe((resp: any) => {
    //           this.fireRejectEvent.emit({target: e, apiUrl: `cac/action/${this.actionData()?.id}/reject_line_items`});
    //           const { data } = resp;
    //           if(data?.result?.chats){
    //             // this.firePopupCloseEvent.emit();
    //             this.actionDataSig.update(prev  => ({
    //               ...prev,
    //               chats: data.result.chats
    //             }));

    //             this.chatMsg.message = '';
    //             this.chatFile?.clearAll();
    //             this.setDisabledSendButton(this.chatMsg.message);
    //             this.grid?.refresh();
    //           }
    //         })
    //       }
    //     }); 
    //     return
    // }
    
    
    this.actionData()?.lineItems.forEach(item => {
      if (selectedItems.some((sel: any) => sel.id === item.id)) {
        item.actionType = item.prevActionType = 'Requested';
      }
    });

    const formData = new FormData();
    const files = this.chatFile.getFilesData();
    if (files.length > 0) {
      const file = files[0];
      const ticks = Date.now();
      formData.append('file', new File([file.rawFile], `${file.name}`, { type: this.getContentType(file.name) }));
    }
    formData.append('chatMsg', JSON.stringify(this.chatMsg));
    formData.append('lineItems', JSON.stringify(this.lineItems()));
    formData.append('actionType', JSON.stringify({actionType: 'request_line_items'}));
    this.fireRequestInfoEvent.emit({target: e, formData: formData});

    this.chatMsg.message = '';
    this.chatFile?.clearAll();
    this.setDisabledSendButton(this.chatMsg.message);
    this.grid?.refresh();
  }

  onApproveClick(e: any){
    if (this.actionButton()?.disabledApproved) {
      return;
    }

    const selectedItems: any = this.grid?.getSelectedRecords();
    if(selectedItems && selectedItems.length == 0){
      this._toastr.showInfo('Please select at least one line item to proceed with approval.');
      return;
    }

    if (this.actionData()?.additional?.approvers
      && this.actionData()?.additional?.approvers[0]?.isSSAApprover) {
       this.lineItems()?.map(m => {
        if(m.isContracted){
          m.actionType = m.prevActionType ;
        }
      });
    }

    this.lineItems()?.filter(f => selectedItems.map((m: any) => m.id).includes(f.id)).map(m => {
      m.actionType = m.prevActionType = 'Approved';
    });
    const confirmationMessage = `Are you sure you want to approve ?`;
    const confirmation = this._fuseConfirmationService.open(
      {
        title: 'Confirmation',
        message: confirmationMessage,
        panelClass: "archive-dialog-panel",
        dismissible: true,
        icon: {
          show: true,
          color: 'info'
        },
        actions: {
          confirm: {
            show: true,
            label: 'Confirm',

          },
          cancel: {
            show: true,
            label: 'Cancel'
          }
        }
      }
    );
    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
          this.isRejecting.set(false);
          this.visibleSendComment = false;
          this.fireApproveEvent.emit({target: e, apiUrl: `cac/action/${this.actionData()?.id}/approve_line_items`});
      }
    });
  }

  @ViewChild('dialogObj') public dialogObj!: DialogComponent;
  rejectReason = '';
  onRejectClick(e: any){
    if (this.actionButton()?.disabledReject) {
      return;
    }

    const selectedItems: any = this.grid?.getSelectedRecords();
    if(selectedItems && selectedItems.length == 0){
      this._toastr.showInfo('Please select at least one line item to proceed with rejection.');
      return;
    }

    this.rejectReason = '';
    this.isRejectSubmitting = false;
    this.setDisabledRejectConfirmButton(this.rejectReason);
    this.dialogObj.show();

  //   if(this.actionData().additional?.approvers && this.actionData().additional?.approvers[0]?.isSSAApprover){
  //      this.lineItems().map(m => {
  //       if(m.isContracted){
  //         m.actionType = m.prevActionType;
  //       }
  //     });
  //   }

  //   // this.lineItems().filter(f => selectedItems.map(m => m.id).includes(f.id)).map(m => {
  //   //   m.actionType = m.prevActionType = 'Rejected';
  //   // });

  //  this._toastr.showInfo('Please enter rejection reason before rejecting.');
  //  this.visibleSendComment = true; //= !this.visibleSendComment;
 
  //  if(this.visibleSendComment){
  //     const interval = setInterval(() => {
  //       if(this.comment){
  //         clearInterval(interval);
  //         this.isRejecting.set(true);
  //         this.chatMsg.message = '';
  //         this.chatFile?.clearAll();
  //         this.comment.focusIn();
  //       }      
  //     }, 200);
  //   }
  }

  confirmReject(e: any){
    if(this.isRejectSubmitting){
      return;
    }
    this.isRejectSubmitting = true;
    this.disabledRejectConfirmButton.set(true);

    if(this.actionData()?.additional?.approvers && this.actionData()?.additional?.approvers[0]?.isSSAApprover){
       this.lineItems()?.map(m => {
        if(m.isContracted){
          m.actionType = m.prevActionType;
        }
      });
    }

    const selectedItems: any = this.grid?.getSelectedRecords();
    const formData = new FormData();
    formData.append('chatMsg', JSON.stringify({message: `${this.rejectReason}`}));
    
    this.lineItems()?.filter(f => selectedItems?.map((m: any) => m.id).includes(f.id)).map(m => {
      m.actionType = m.prevActionType = 'Rejected';
    });

    this._cacService.sendRejctMessage(this.actionData()?.id, formData).subscribe({
      next: (resp: any) => {
        this.fireRejectEvent.emit({target: e, apiUrl: `cac/action/${this.actionData()?.id}/reject_line_items`});
        const { data } = resp;
        if(data?.result?.chats){
          // this.firePopupCloseEvent.emit();
          this.actionDataSig.update(prev  => ({
            ...prev,
            chats: data.result.chats
          }));

          this.closeDialog();
          this.rejectReason = '';
          this.grid?.refresh();
        }

        this.isRejectSubmitting = false;
        this.setDisabledRejectConfirmButton(this.rejectReason);
      },
      error: () => {
        this.isRejectSubmitting = false;
        this.setDisabledRejectConfirmButton(this.rejectReason);
      }
    })
  }

  viewQuoteFile(quote: any){
    // quote.uploadUrl = 'https://cdn.syncfusion.com/content/pdf/pdf-succinctly.pdf'
    // quote.uploadUrl = 'https://itmagnet.blob.core.windows.net/fw-dms/PurchaseRequisition/1746002356283_ACT.png';
    // quote.uploadUrl = 'https://itmagnet.blob.core.windows.net/fw-dms/PurchaseRequisition/1746532079320_5WABDN_ticket.pdf';
      // quote.uploadUrl = 'https://youngendeavour.gov.au/wp-content/uploads/2021/08/Young-Endeavour-youth-program-learn-life-skills-tall-ship-1.jpg'
    this.dialog.open(DocumentViewerModalComponent, {
      width: '80%',
      height: '80%',
      // disableClose: true,
      data: { fileUrl: quote.uploadUrl }
    });
  }

  viewChatFile(chat: any){
    // quote.uploadUrl = 'https://cdn.syncfusion.com/content/pdf/pdf-succinctly.pdf'
    // quote.uploadUrl = 'https://itmagnet.blob.core.windows.net/fw-dms/PurchaseRequisition/1746002356283_ACT.png';
    // quote.uploadUrl = 'https://itmagnet.blob.core.windows.net/fw-dms/PurchaseRequisition/1746532079320_5WABDN_ticket.pdf';
      // quote.uploadUrl = 'https://youngendeavour.gov.au/wp-content/uploads/2021/08/Young-Endeavour-youth-program-learn-life-skills-tall-ship-1.jpg'
    this.dialog.open(DocumentViewerModalComponent, {
      width: '80%',
      height: '80%',
      // disableClose: true,
      data: { fileUrl: chat.fileUrl }
    });
  }

  onCommentChange(e: any){
    this.setDisabledSendButton(e.value);
  }

  onRejectReasonChange(e: any){
    this.setDisabledRejectConfirmButton(e.value);
  }

  setDisabledSendButton(value: any) {
    if(value && value.trim().length >= 20){
      this.disabledSendButton.set(false);
    } else {
      this.disabledSendButton.set(true);
    }
  }

  setDisabledRejectConfirmButton(value: any) {
    if(value && value.trim().length >= 5){
      this.disabledRejectConfirmButton.set(false);
    } else {
      this.disabledRejectConfirmButton.set(true);
    }
  }

  onDetailsClick(e: any, rowData: any, grid: GridComponent): void {
    console.log(e)
    e.stopPropagation();
    const rowIndex = grid.getRowIndexByPrimaryKey(rowData.id);
    const row = grid.getRowByIndex(rowIndex);
    const nextRow = row?.nextElementSibling;
    // Look for whether the row is already expanded
    const isExpanded = nextRow?.classList.contains('e-detailrow');
    if (isExpanded) {
      grid.detailRowModule?.collapse(rowIndex);
      grid.refresh();
      // nextRow.remove();
    } else {
      grid.detailRowModule?.expand(rowIndex);
    }

    const element = e.currentTarget as HTMLElement;
    if (element.classList.contains('e-swimlane-row-collapse')) {
      element.classList.remove('e-swimlane-row-collapse');
      element.classList.add('e-swimlane-row-expand');
    } else {
      element.classList.remove('e-swimlane-row-expand');
      element.classList.add('e-swimlane-row-collapse');
    }
  }

  // Reject dialog methods
  closeDialog(): void {
    this.dialogObj.hide();
  }

  onDialogClose(): void {
    console.log('Dialog closed');
  }
  
}